export enum StockApiUrls {
  Stocks = "/v1/Stocks",
}
